import { FaultData } from "@fairfleet/geotab";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { DateCell } from "../../cells/DateCell";
import FaultCodeCell from "../../cells/FaultCodeCell";
import { FaultNameCell } from "../../cells/FaultNameCell";
import { NoRowsOverlay } from "../../NoRowsOverlay";
import { I18nGrid } from "@/components/data/I18nGrid";
import AddInIds from "@/constants/AddInIds";
import { useAddinData } from "@/hooks/addins/useAddinData";
import { useSortedFaultData } from "@/hooks/faultData/useSortedFaultData";
import { DiagnosticAddinData } from "@/pages/diagnostic-edit/models/DiagnosticAddinData";

export default function FaultTable({
  faultData,
  isLoading,
  setSelectedFault,
  selectable = true, // if not selectable its used for detail view, so dont show code column
  maxHeight = "40vh",
  deviceGroupIds = [],
}: {
  faultData: FaultData[];
  isLoading: boolean;
  setSelectedFault?: Dispatch<SetStateAction<FaultData | null>>;
  selectable?: boolean;
  maxHeight?: string;
  deviceGroupIds?: string[];
}) {
  const { t } = useTranslation();
  const { data: descriptions = [] } = useAddinData<DiagnosticAddinData>(AddInIds.diagnosticData);

  const sortedFaults = useSortedFaultData(faultData, descriptions, deviceGroupIds);

  if (faultData.length === 0) return <></>;

  return (
    <I18nGrid
      sx={{
        width: "100%",
        maxHeight,
        "& .MuiDataGrid-row:hover": {
          cursor: "help",
        },
        "& .Mui-selected": {
          backgroundColor: "rgba(25, 118, 210, 0.2) !important",
        },
        "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
          outline: "none",
        },
      }}
      density="compact"
      onRowClick={row => setSelectedFault && setSelectedFault(row.row)}
      columns={[
        {
          field: "faultState",
          headerName: t("faultOverview.diagnosticStatus"),
          flex: 0.5,
          //width: columnWidths.faultState,
        },
        ...(selectable
          ? [
              {
                field: "diagnostic.id",
                headerName: "Name",
                flex: 1,
                //width: columnWidths.diagnostic,
                renderCell: FaultNameCell,
              },

              {
                field: "diagnostic",
                headerName: "Code",
                flex: 0.5,
                // width: columnWidths.diagnostic,
                renderCell: FaultCodeCell,
              },
            ]
          : []),
        {
          field: "dateTime",
          headerName: t("faultOverview.date"),
          type: "dateTime",
          flex: 0.5,
          //  width: columnWidths.dateTime,
          renderCell: DateCell,
        },
      ]}
      slots={{
        noRowsOverlay: NoRowsOverlay,
      }}
      loading={isLoading}
      rows={sortedFaults}
      hideFooter
      rowSelection={selectable}
      disableAutosize
      disableColumnResize
      disableColumnPinning
      disableColumnReorder
    />
  );
}
